import { LockAuditLog, LockAuditLogTitle } from '../types';
import formatDate from '../../../helpers/format-date';

const formatLogsList = (list: LockAuditLog[]): LockAuditLog[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {};
    render.result = (
      <div>{`${result.result.charAt(0)}${result.result
        .slice(1)
        .toLowerCase()}`}</div>
    );
    render.action = <div>{LockAuditLogTitle[result.action]}</div>;
    render.userId = <div>{result.userId || '-'}</div>;
    render.eventCreatedAt = (
      <div>
        {result.eventCreatedAt ? formatDate(result.eventCreatedAt, true) : '-'}
      </div>
    );

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatLogsList;
